export default __webpack_public_path__ + "static/media/hana.43e09728.jpeg";